import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, Grid, TextField, CircularProgress } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { PageLoader } from '../../../shared_elements'
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { fieldDateFormat, backendDateFormat } from '../../../constants';
import { regexConstants } from '../../../constants/regEx';
import { globalGetService, globalPostService, globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus, downloadFileType, getLocalStorageInfo, removeEmptyKey, capitalizeFirstLetter } from '../../../utils';
import { Today } from '@material-ui/icons';
const EditAssembly = ({addEditAssembly, toggleModalFn, getResponseBack, tabIndex, addEditModuleType}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [formData, setFormData] = useState(addEditAssembly.data);
    const [error, setError] = useState({});
    const [assetsOptions, setAssetsOptions] = useState([]);
    const [regionsOfOperation, setRegionsOfOperations] = useState([]);
    const [maintenancePrograms, setMaintenancePrograms] = useState([]);
    const [assetAircraftTypes, setAssetAircraftTypes] = useState([]);
    useEffect(() => {
        getAssetsTypes();
        getRegionOfOperation();
        if (tabIndex === 'apu' || tabIndex === 'lg') {
            getAssetsAircraftTypes();
        }
    },[]);
    const getAssetsTypes = () => {
        let url = '';
        url = tabIndex === 'airframe' ? 'console/aircraft-types/' : 
              tabIndex === 'engines' ? 'console/engine-types/' : 
              tabIndex === 'apu' ? 'console/apu-types/' : '';
        globalGetService(url, {'mr-calculator': 'mr-calculator'})
        .then(response => {
            if(checkApiStatus(response)){
                if (tabIndex === 'airframe') {
                    setAssetsOptions(response.data.data.aircraftTypes);
                    if (addEditAssembly.mode === 'edit' && addEditAssembly.data.asset === 'airframe' && addEditAssembly.data.asset_type) {
                        getMaintenacePrograms(addEditAssembly.data.asset_type)
                    }
                } else if (tabIndex === 'engines') {
                    setAssetsOptions(response.data.data.engineTypes);
                } else if (tabIndex === 'apu') {
                    setAssetsOptions(response.data.data.apu_types);
                } else {}
            }
        });
    }
    const getRegionOfOperation = () => {
        globalGetService('console/regions/')
        .then(response => {
            if(checkApiStatus(response)){
                setRegionsOfOperations(response.data.data.region_list);
            }
        })
    }
    const getMaintenacePrograms = (aircraftType) => {
        globalGetService(`console/aircraft-type/${aircraftType.id}/events/`, {'mr-calculator':'mr-calculator', list: true})
        .then(response => {
            if(checkApiStatus(response)){
                setMaintenancePrograms(response.data.data);
            }
        })
    }
    const getAssetsAircraftTypes = () => {
        globalGetService('console/aircraft-types/', {'mr-calculator': 'mr-calculator'})
        .then(response => {
            if(checkApiStatus(response)){
                setAssetAircraftTypes(response.data.data.aircraftTypes);
            }
        })
    }
    const onFieldChange = (key, value) => {
        setFormData({...formData, [key]:value});
        if (tabIndex === 'airframe' && key === 'asset_type') {
            getMaintenacePrograms(value)
        }
    }
    const onAddEditAssembly = () => {
        let validationInputs = {
            
        };
        if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
            setLoading(true);
            if(formData.id){
                globalPutService(`new-mr-calculator/fleet-portfolio/`, {...formData, module_type:addEditModuleType, asset:tabIndex})
                .then(response => {
                    if(checkApiStatus(response)){
                        toggleModalFn();getResponseBack();
                        enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                    }else{
                        enqueueSnackbar(response.data.message, { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}});
                    }
                    setLoading(false);
                })
                .catch(error => {
                    setLoading(false);
                })
            }else{
                globalPostService(`new-mr-calculator/fleet-portfolio/`, {...formData, module_type:addEditModuleType, asset:tabIndex})
                .then(response => {
                    if(checkApiStatus(response)){
                        toggleModalFn();getResponseBack();
                        enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                    }else{
                        enqueueSnackbar(response.data.message, { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}});
                    }
                    setLoading(false);
                })
                .catch(error => {
                    setLoading(false);
                })
            }
        }else{
            setError(validationInputs);
        }
    }
    return(
        <>
            <Dialog
                open={addEditAssembly.modal}
                onClose={toggleModalFn}
                className='console-management-modal'
                maxWidth='md'
            >
                <DialogTitle id="scroll-dialog-title">
                    {formData.id ?'Edit':'Add'} {capitalizeFirstLetter(tabIndex)} Assembly
                </DialogTitle>
                <DialogContent dividers={true}>
                    <Grid container spacing={1}>
                        <Grid item md={4}>
                            <TextField 
                                required
                                disabled={true}
                                id='serial_number'
                                label='Serial Number'
                                value={formData?.serial_number||''}
                                fullWidth
                                margin="normal"
                                error={error?.serial_number?true:false}
                                helperText={error?.serial_number||''}
                                onChange={(e) => onFieldChange('serial_number', e.target.value)}
                                onFocus={() => setError({...error, 'serial_number':''})}
                                InputLabelProps={{shrink: true}}
                                variant='outlined'
                            />
                        </Grid>
                        { tabIndex !== 'lg' ?
                            <Grid item md={4}>
                                <Autocomplete
                                    disabled={true}
                                    options = {assetsOptions}
                                    getOptionLabel={option => option.name}
                                    id="asset_type"
                                    value={formData?.asset_type||null}
                                    onChange={(e, value) => onFieldChange('asset_type', value)}
                                    renderInput={params => <TextField required error={error?.asset_type ? true:false} helperText={error?.asset_type||''} onFocus={() => setError({...error, asset_type:''})} {...params} label="Asset Type" placeholder="Select Asset Type" margin="normal" fullWidth InputLabelProps={{shrink: true}} variant="outlined" />}
                                />
                            </Grid>: null
                        }
                        { tabIndex !== 'engines' ?
                            <Grid item md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        required
                                        disabled={true}
                                        margin="normal"
                                        id="date_of_manufacture"
                                        label="Date of Manufacture"
                                        format={fieldDateFormat}
                                        fullWidth
                                        disableFuture
                                        minDate={moment().subtract(50, 'years')}
                                        InputLabelProps={{shrink: true}}
                                        value={formData?.date_of_manufacture||null}
                                        error={error?.date_of_manufacture ? true:false}
                                        helperText={error?.date_of_manufacture||''}
                                        onChange={(data, value) => {onFieldChange('date_of_manufacture', data ? moment(data).format(backendDateFormat):data);}}
                                        inputVariant="outlined"
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>:null
                        }
                        { tabIndex === 'airframe' || tabIndex === 'engines' ?
                            <Grid item md={4}>
                                <Autocomplete
                                    options = {regionsOfOperation}
                                    getOptionLabel={option => option.name}
                                    id="region_of_operation"
                                    value={formData?.region_of_operation ? formData.region_of_operation : (formData?.region_of_operation||null)}
                                    disabled={true}
                                    onChange={(e, value) => onFieldChange('region_of_operation', value)}
                                    renderInput={params => <TextField required={tabIndex === 'engines' ?true:false} error={error?.region_of_operation ? true:false} helperText={error?.region_of_operation||''} onFocus={() => setError({...error, region_of_operation:''})} {...params} label="Region of Operation" placeholder="Select Region of Operation" margin="normal" fullWidth InputLabelProps={{shrink: true}} variant="outlined" />}
                                />
                            </Grid>:null
                        }
                        { tabIndex === 'airframe' ?
                            <Grid item md={4}>
                                <Autocomplete
                                    disabled={true}
                                    options = {maintenancePrograms}
                                    getOptionLabel={option => option.name}
                                    id="maintenance_program"
                                    value={formData?.extras?.maintenance_check?.name + 'Years' ||null}
                                    onChange={(e, value) => onFieldChange('maintenance_program', value)}
                                    renderInput={params => <TextField required error={error?.extras?.maintenance_check?.name ? true:false} helperText={error?.extras?.maintenance_check?.name||''} onFocus={() => setError({...error, maintenance_program:''})} {...params} label="Maintenance Program" placeholder="Select Maintenance Program" margin="normal" fullWidth InputLabelProps={{shrink: true}} variant="outlined" />}
                                />
                            </Grid>:null
                        }
                        { tabIndex !== 'lg' && tabIndex != 'airframe' ?
                            <Grid item md={4}>
                                <TextField 
                                    required = {tabIndex === 'airframe' ? false : true}
                                    id='hours'
                                    label='Avg. Hours'
                                    value={formData?.hours ? formData.hours : (formData?.hours||'')}
                                    fullWidth
                                    margin="normal"
                                    error={error?.hours?true:false}
                                    helperText={error?.hours||''}
                                    disabled={true}
                                    onChange={(e) => {regexConstants.numberWithDot.test(e.target.value) ? onFieldChange('hours', e.target.value):e.preventDefault()}}
                                    onFocus={() => setError({...error, 'hours':''})}
                                    InputLabelProps={{shrink: true}}
                                    variant='outlined'
                                />
                            </Grid>:null
                        }
                        { tabIndex !== 'apu' && tabIndex != 'airframe' ?
                            <Grid item md={4}>
                                <TextField 
                                    required = {tabIndex === 'airframe' ? false : true}
                                    id='cycles'
                                    label='Avg. Cycles'
                                    value={formData?.cycles ? formData.cycles : (formData?.cycles||'')}
                                    fullWidth
                                    margin="normal"
                                    error={error?.cycles?true:false}
                                    helperText={error?.cycles||''}
                                    disabled={true}
                                    onChange={(e) => {regexConstants.numberWithDot.test(e.target.value)?onFieldChange('cycles', e.target.value):e.preventDefault()}}
                                    onFocus={() => setError({...error, 'cycles':''})}
                                    InputLabelProps={{shrink: true}}
                                    variant='outlined'
                                />
                            </Grid>:null
                        }
                        { tabIndex != 'airframe' ?
                            <Grid item md={4}>
                                <TextField 
                                    required={tabIndex === 'engines'?true:false}
                                    id='tsn'
                                    label='TSN'
                                    value={formData?.tsn||''}
                                    fullWidth
                                    margin="normal"
                                    onChange={(e) => {regexConstants.numberWithDot.test(e.target.value) ? onFieldChange('tsn', e.target.value):e.preventDefault()}}
                                    InputLabelProps={{shrink: true}}
                                    variant='outlined'
                                />
                            </Grid>:null
                        }
                        { tabIndex != 'airframe' ?
                            <Grid item md={4}>
                                <TextField 
                                    required={tabIndex === 'engines'?true:false}
                                    id='csn'
                                    label='CSN'
                                    value={formData?.csn||''}
                                    fullWidth
                                    margin="normal"
                                    onChange={(e) => {regexConstants.numberWithDot.test(e.target.value) ? onFieldChange('csn', e.target.value): e.preventDefault()}}
                                    InputLabelProps={{shrink: true}}
                                    variant='outlined'
                                />
                            </Grid>:null
                        }
                        { tabIndex != 'airframe' ?
                            <Grid item md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        required
                                        margin="normal"
                                        id="as_of_date"
                                        label="As of Date"
                                        format={fieldDateFormat}
                                        fullWidth
                                        minDate={moment().subtract(50, 'years')}
                                        InputLabelProps={{shrink: true}}
                                        value={formData?.as_of_date||null}
                                        error={error?.as_of_date ? true:false}
                                        helperText={error?.as_of_date||''}
                                        onChange={(data, value) => {onFieldChange('as_of_date', data ? moment(data).format(backendDateFormat):data);}}
                                        inputVariant="outlined"
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>:null
                        }
                        { tabIndex !== 'airframe' ?
                            <>
                                <Grid item md={4}>
                                    <Autocomplete
                                        options = {["Spare", "Titled"]}
                                        id="status"
                                        value={formData?.status||null}
                                        onChange={(e, value) => onFieldChange('status', value)}
                                        renderInput={params => <TextField required error={error?.status ? true:false} helperText={error?.status||''} onFocus={() => setError({...error, status:''})} {...params} label="Status" placeholder="Select Status" margin="normal" fullWidth InputLabelProps={{shrink: true}} variant="outlined" />}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <TextField 
                                        id='on_wing_msn'
                                        label='On Wing MSN'
                                        value={formData?.on_wing_msn||null}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => onFieldChange('on_wing_msn', e.target.value)}
                                        InputLabelProps={{shrink: true}}
                                        variant='outlined'
                                    />
                                </Grid>
                            </>
                            :null
                        }
                        { tabIndex === 'apu' || tabIndex === 'lg' ?
                            <Grid item md={4}>
                                <Autocomplete
                                    options = {assetAircraftTypes}
                                    getOptionLabel={option => option.name}
                                    id="asset_aircraft_type"
                                    value={formData?.asset_aircraft_type||null}
                                    onChange={(e, value) => onFieldChange('asset_aircraft_type', value)}
                                    renderInput={params => <TextField required error={error?.asset_aircraft_type ? true:false} helperText={error?.asset_aircraft_type||''} onFocus={() => setError({...error, asset_aircraft_type:''})} {...params} label="Aircraft Type" placeholder="Select Aircraft Type" margin="normal" fullWidth InputLabelProps={{shrink: true}} variant="outlined" />}
                                />
                            </Grid>:null
                        }
                        { tabIndex !== 'engines' ?
                            <Grid item md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        required
                                        margin="normal"
                                        id="nsv_date"
                                        label="Next Due Date"
                                        format={fieldDateFormat}
                                        fullWidth
                                        minDate={moment(Today)}
                                        InputLabelProps={{shrink: true}}
                                        value={formData?.nsv_date||null}
                                        error={error?.nsv_date ? true:false}
                                        helperText={error?.nsv_date||''}
                                        onChange={(data, value) => {onFieldChange('nsv_date', data ? moment(data).format(backendDateFormat):data);}}
                                        inputVariant="outlined"
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>:null
                        }
                        { tabIndex !== 'engines' ?
                            <Grid item md={4}>
                                <TextField 
                                    id='sv_cost'
                                    label='Event Cost'
                                    value={formData?.sv_cost||null}
                                    fullWidth
                                    margin="normal"
                                    onChange={(e) => onFieldChange('sv_cost', e.target.value)}
                                    InputLabelProps={{shrink: true}}
                                    variant='outlined'
                                />
                            </Grid>:null
                        }
                        { tabIndex === 'engines' ?
                            <Grid item md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        required
                                        margin="normal"
                                        id="nsv_date"
                                        label="PRSV Next Due"
                                        format={fieldDateFormat}
                                        fullWidth
                                        minDate={moment(Today)}
                                        InputLabelProps={{shrink: true}}
                                        value={formData?.nsv_date||null}
                                        error={error?.nsv_date ? true:false}
                                        helperText={error?.nsv_date||''}
                                        onChange={(data, value) => {onFieldChange('nsv_date', data ? moment(data).format(backendDateFormat):data);}}
                                        inputVariant="outlined"
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>:null
                        }
                        { tabIndex === 'engines' ?
                            <Grid item md={4}>
                                <TextField 
                                    id='sv_cost'
                                    label='PRSV Cost'
                                    value={formData?.sv_cost||null}
                                    fullWidth
                                    margin="normal"
                                    onChange={(e) => onFieldChange('sv_cost', e.target.value)}
                                    InputLabelProps={{shrink: true}}
                                    variant='outlined'
                                />
                            </Grid>:null
                        }
                        { tabIndex === 'engines' ?
                            <Grid item md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        required
                                        margin="normal"
                                        id="llp_nsv_date"
                                        label="LLP Next Due"
                                        format={fieldDateFormat}
                                        fullWidth
                                        minDate={moment(Today)}
                                        InputLabelProps={{shrink: true}}
                                        value={formData?.extras?.llp_data?.nsv_date ||null}
                                        error={error?.extras?.llp_data?.nsv_date ? true:false}
                                        helperText={error?.extras?.llp_data?.nsv_date ||''}
                                        onChange={(data, value) => {onFieldChange('nsv_date', data ? moment(data).format(backendDateFormat):data);}}
                                        inputVariant="outlined"
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>:null
                        }
                        { tabIndex === 'engines' ?
                            <Grid item md={4}>
                                <TextField 
                                    id='llp_sv_cost'
                                    label='LLP Cost'
                                    value={formData?.extras?.llp_data?.sv_cost ||null}
                                    fullWidth
                                    margin="normal"
                                    onChange={(e) => onFieldChange('sv_cost', e.target.value)}
                                    InputLabelProps={{shrink: true}}
                                    variant='outlined'
                                />
                            </Grid>:null
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                    <Button disabled={isLoading} onClick={onAddEditAssembly} color='primary' size='small' variant='contained'>
                        {isLoading ? <CircularProgress size={20} /> :'Save'}
                    </Button>
                </DialogActions>
                {
                    isLoading ? <PageLoader/> : null
                }
            </Dialog>
        </>
    )
}
export default EditAssembly;